module.exports = __webpack_public_path__ + "img/hospital.cb48606c.jpeg";